import { useCallback } from 'react'
import BigNumber from 'bignumber.js'
import { getSigner } from 'state/web3/account'
import { getLoadedDeserializedFarmFromPid } from 'state/farms/useDeserializedFarms'
import {
  getLoadedDeserializedFarmUserDataFromPid,
  refreshFarmUserDataFromPid,
} from 'state/farms/useDeserializedFarmsUser'
import { stakeFarm } from 'utils/calls'
import { getAddress } from 'utils/addressHelpers'
import { useCraftsmanV2 } from 'hooks/useContract'
import { useCallWithGasPrice } from 'hooks/useCallWithGasPrice'
import { getCrc20Contract } from 'utils/contractHelpers'
import { DEFAULT_GAS_LIMIT_CRAFTSMAN_V2, DEFAULT_TOKEN_DECIMAL } from 'config'

const useStakeFarmsV2 = (pid: number) => {
  const craftsmanV2Contract = useCraftsmanV2()
  const { callWithGasPrice } = useCallWithGasPrice()

  const handleStake = useCallback(
    async (amount: string) => {
      const userData = await getLoadedDeserializedFarmUserDataFromPid(pid, 2)
      if (userData.allowance.div(DEFAULT_TOKEN_DECIMAL).isLessThan(amount)) {
        const farm = await getLoadedDeserializedFarmFromPid(pid, 2)
        const lpContract = getCrc20Contract(getAddress(farm.lpAddresses), getSigner())
        const approvalTx = await callWithGasPrice(lpContract, 'approve', [
          craftsmanV2Contract.address,
          new BigNumber(amount).times(DEFAULT_TOKEN_DECIMAL).toString(),
        ])
        console.info(approvalTx)
        await approvalTx.wait()
      }

      const txHash = await stakeFarm(craftsmanV2Contract, pid, amount, DEFAULT_GAS_LIMIT_CRAFTSMAN_V2)
      refreshFarmUserDataFromPid(pid, 2)
      console.info(txHash)
    },
    [craftsmanV2Contract, pid, callWithGasPrice],
  )

  return { onStake: handleStake }
}

export default useStakeFarmsV2
